import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImporterService } from 'src/app/core/services/importer.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/core/services/language.service';

@Component({
  selector: 'app-importers',
  templateUrl: './importers.component.html',
  styleUrls: ['./importers.component.css']
})
export class ImportersComponent implements OnInit {

  @Input() currentUser: any;
  @Input() userId: string;
  @Input() selectedSetting: any;
  @Output() reloadFeatures = new EventEmitter();


  connectModal;
  dmsModal;

  importers;
  userImporters;
  selectedImporter;
  selectedImporterCredentials;

  isConnecting = false;

  language = 'en';

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal'
  };

  constructor(
    private modalService: NgbModal,
    private importerService: ImporterService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    this.language = languageService.currentLanguage;
   }

  ngOnInit(): void {
    this.loadImporters();
  }

  loadImporters() {
    // all importers
    this.importerService.getAllImporters().subscribe(allImporters => {
      this.importers = allImporters;

      // user importers
      this.importerService.getUserImporters(this.userId, this.selectedSetting?.id)
        .subscribe(res => {
          this.userImporters = res;

          this.importers.forEach(importer => {

            importer.isConnected = false;

            if (this.userImporters.length) {
              this.userImporters.forEach(userImporter => {
                if (importer.id === userImporter.importerId) {
                  importer.isConnected = true;
                }
              });
            }

          });
        });
    });
  }

  openAvailableImporters(content) {
    this.dmsModal = this.modalService.open(content, this.dialogOptions);
    this.dmsModal.result.then((result) => {
      
    }, (reason) => {

    });
  }

  deleteUserImporter(importer) {
    this.importerService.deleteUserImporter(this.userId, importer.importerId, this.selectedSetting?.id).subscribe(res => {
      this.loadImporters();
      this.reloadFeatures.emit();
    });
  }

  patchUserImporter(importerId: string, body) {
    this.importerService
      .updateUserImporter(this.userId, importerId, body, this.selectedSetting?.id)
      .subscribe(
        (res) => {
          this.loadImporters();
          this.connectModal.close();
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
  }

  patchAutoImport({ event, data }) {
    const autoImport = event.target.checked;

    const body = {
      autoImport
    };

    this.patchUserImporter(data.importerId, body)
  }

  openConnectImporterModal(content, importer) {
    this.selectedImporter = importer;
    this.selectedImporterCredentials = null;

    this.connectModal = this.modalService.open(content, this.dialogOptions);
    this.connectModal.result.then((result) => {
      
    }, (reason) => {

    });
  }

  connectToImporter(form) {
    this.isConnecting = true;
    let credentials = {};

    let error = Object.entries(form.form.value).some(([key, value], index) => {
      return value === '';
    });

    if (error) {
      this.isConnecting = false;
      return this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    Object.entries(form.form.value).forEach(([key, value], index) => {
      credentials[key] = value;
    });

    const body = {
      importerId: this.selectedImporter.id,
      credentials
    };

    this.importerService.addUserImporter(this.userId, body, this.selectedSetting?.id)
      .subscribe(
        res => {
          this.toastr.success(`Connected to ${res.importer.name}`);
          
          this.loadImporters();
          this.reloadFeatures.emit();
          this.connectModal.close();
          this.dmsModal.close();
          this.isConnecting = false;
        },
        err => {
          this.toastr.error(err.message);
          this.isConnecting = false;
        });
  }

  getFieldLanguage(fields) {
    let lang = Object.entries(fields).find(([key, value]) => {
      return key === this.language;
    })

    if (lang) {
      return lang[1];
    } else {
      return fields.en;
    }
  }
  
  openEditImporter(content, importer) {
    console.log(importer)
    this.selectedImporter = importer.importer;
    this.selectedImporterCredentials = importer.credentials;
    
    this.connectModal = this.modalService.open(content, this.dialogOptions);
    this.connectModal.result.then((result) => {
      
    }, (reason) => {

    });
  }

  editUserImport(form) {
    let error = Object.entries(form.form.value).some(([key, value], index) => {
      return value === '';
    });

    if (error) {
      this.isConnecting = false;
      return this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
    
    const credentials = form.form.value;
    const body = {
      credentials,
    };
    this.patchUserImporter(this.selectedImporter.id, body)
  }

}
